import React, {FC, useEffect, useState} from "react";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import {useTranslation} from "react-i18next";
interface EventsListProps {
    stakes: any[];
    styles: any;
    operator: string,
    prices: number[];
    setStake: (stake: number) => void;
    setPrice: (stake: number) => void;
    isOpen: boolean
    marketsCount?: {
        totalMarket: number,
        markedMarket: number
    },
}
const StakeList: FC <EventsListProps> = ({stakes,setPrice, operator, setStake, styles, prices, marketsCount, isOpen}) => {
    const { operatorData } = useTypedSelector((state) => state.operatorReducer);
    const [selectedStake, setSelectedStake] = useState<number>(stakes[0]);
    const [selectedPrice, setSelectedPrice] = useState<number>(prices[0]);
    const { t } = useTranslation();
    const [openInput, setOpenInput] = useState(false);
    const handleStakeValue = (stake: number, price:number) => {

        setSelectedStake(Number(stake.toFixed(2)));
        calculateStakeVal(price, operatorData.exercise_tax);
    }
    let calculateStakeVal = (price: number, tax: number) => {
        const taxRate = tax / 100;
        const taxValue = price * taxRate;
        const finalPrice = price - taxValue;

        setSelectedStake(finalPrice);
        setSelectedPrice(price);
    };
    useEffect(()=>{
        if (stakes.length > 0) {
            setStake(selectedStake)
            setPrice(selectedPrice)
        }
    }, [selectedStake])
    return(
        <div className='stake-action'>
            <ul className='stake-list p-2'>
                {
                    prices.map((item: number, index) => {
                        return(
                            <li key={index}
                                className='stake-list-item pt-2 pb-2'
                                onClick={()=> {handleStakeValue(stakes[index], item); setOpenInput(false)}}
                                style={{
                                    borderColor: item === selectedPrice ? styles.colors.buttonBGColor :  styles.colors.buttonFontColor,
                                    background: item === selectedPrice ? styles.colors.buttonFontColor : styles.colors.buttonBGColor,
                                    color: item === selectedPrice ?  styles.colors.buttonBGColor : styles.colors.buttonFontColor
                                }}
                            >
                                {prices[index]}
                            </li>
                        )
                    })
                }
                {
                    isOpen ?
                        <li className='stake-list-item pt-2 pb-2'
                            onClick={()=> setOpenInput(true)}
                            style={{
                                border: operator === '888-demo' ? `1px solid ${styles.colors.buttonFontColor}` : `none`,
                                background: openInput ? `${styles.colors.buttonFontColor}` : 'none',
                                color: openInput ? `${styles.colors.blockBgColor}` : styles.colors.buttonFontColor
                            }}
                        >
                            {t('quickbet.priceBlock.otherBtn')}
                        </li>
                        :null
                }
            </ul>
            {
                openInput ?
                    <div className="custom-value">
                        <div className="input-group input-group-sm mb-3">
                            <input type="number"
                                   className="form-control pt-2 pb-2 stake_fields"
                                   placeholder={t('quickbet.priceBlock.pricePlaceholder')}
                                   onChange={(event) => handleStakeValue(Number(event.target.value), Number(event.target.value))}
                                   style={{
                                       "--placeholder-color": styles.colors.buttonFontColor,
                                       backgroundColor: styles.colors.fieldsBgColor,
                                       color: styles.colors.fieldsFontColor,
                                       border: operator === '888-demo' ? `1px solid ${styles.colors.buttonFontColor}` : `none`,
                                   } as React.CSSProperties}
                            />
                        </div>
                    </div>
                    :null
            }
        </div>

    )
}

export default StakeList;